import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FilterList } from '@/interfaces/person';
import { rolesDictionary, RoleKeys } from '@/auth/enum/auth.enum';
import { tap, debounceTime, switchMap } from 'rxjs/operators';
import { AuthService } from '@/auth/service/auth.service';
import { PersonService } from '@/services/person/person.service';

@Component({
  selector: 'app-form-contract-owner-selector',
  templateUrl: './form-contract-owner-selector.component.html',
  styleUrls: ['./form-contract-owner-selector.component.css'],
})
export class FormContractOwnerSelectorComponent implements OnInit {

  contractOwnerForm = new FormGroup({
    filterText: new FormControl(''),
    id: new FormControl(0, [Validators.required, Validators.min(1)]),
    mdmid: new FormControl('', [Validators.required]),
  });

  @Input() enabled: boolean = true;
  @Input() showTitle: boolean = true;
  @Input() numberSection: number = 0;

  @Output() personSelected = new EventEmitter<string>();

  list: FilterList = [];
  isLoading: boolean = false;

  constructor(
    private readonly auth: AuthService,
    private readonly personService: PersonService,
  ) { }

  ngOnInit(): void {
    const CO_ROLE = Number((<unknown>Object.keys(rolesDictionary) as RoleKeys[]).find((key) => rolesDictionary[key] === 'DLMS_EMPLOYEE_CO'));
    this.contractOwnerForm.controls.filterText.valueChanges
      .pipe(
        tap(() => {
          this.isLoading = true;
        }),
        debounceTime(2000),
        switchMap((value) => {
          this.isLoading = true;
          const iAmFullAccess = this.auth.userHaveRoleClean('DLMS_OWNER_MEL') || this.auth.userHaveRoleClean('DLMS_OWNER_SPC');

          return this.personService.getFilteredListRole(value, CO_ROLE, true, iAmFullAccess);
        }),
      )
      .subscribe({
        next: (options) => {
          this.isLoading = false;
          this.list = options;
        },
      });
  }

  onInputChange(text: string) {
    this.contractOwnerForm.controls.filterText.setValue(text);
  }

  onSelectPerson(id: string) {
    const person = this.list.find(
      (option: any) => +option.id === +id,
    )!;
    const mdmid = person?.mdmid || '';
    this.contractOwnerForm.patchValue({
      id: +id,
      mdmid,
    });
    this.personSelected.emit(mdmid);
  }

}
